import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

export default function LabelValue({ label, value, gutterBottom = true }) {
  return (
    <Box sx={{ mb: gutterBottom ? 4 : 2 }}>
      <Typography variant="h6" gutterBottom>
        {label}
      </Typography>
      <Typography>{value}</Typography>
    </Box>
  );
}

LabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  gutterBottom: PropTypes.bool,
};
